<template>
    <div>
        <!-- Monthly Plan -->
        <div class="benefits" v-if="plan === 'monthly'">
            <div v-if="!couponValid">
                <span class="price">{{ planCost }} / Month</span><br>
                <span class="bill-schedule">Billed Monthly</span>
            </div>
            <div v-if="couponValid">
                <span class="price">Coupon: {{ couponCode.toUpperCase() }}</span><br>
                <span class="bill-schedule">{{ firstCost }} Billed Today</span>
            </div>
        </div>
        <!-- Monthly2 Plan -->
        <div class="benefits" v-if="plan === 'monthly2'">
            <div v-if="!couponValid">
                <span class="price">{{ planCost }} / Month</span><br>
                <span class="bill-schedule">Billed Monthly</span>
            </div>
            <div v-if="couponValid">
                <span class="price">Coupon: {{ couponCode.toUpperCase() }}</span><br>
                <span class="bill-schedule">{{ firstCost }} Billed Today</span>
            </div>
        </div>
        <!-- Monthly3 Plan -->
        <div class="benefits" v-if="plan === 'monthly3'">
            <div v-if="!couponValid">
                <span class="price">{{ planCost }} / Month</span><br>
                <span class="bill-schedule">Billed Monthly</span>
            </div>
            <div v-if="couponValid">
                <span class="price">Coupon: {{ couponCode.toUpperCase() }}</span><br>
                <span class="bill-schedule">{{ firstCost }} Billed Today</span>
            </div>
        </div>

        <!-- Annual Plan -->
        <div v-if="plan === 'annual'">
            <div class="benefits">
                <div v-if="!couponValid">
                    <span class="price">{{ eachBilled }} / Month</span><br>
                    <span class="bill-schedule">{{ planCost }} Billed Yearly - <strong>You Save {{ savings }}</strong></span>
                </div>
                <div v-if="couponValid">
                    <span class="price">Coupon: {{ couponCode.toUpperCase() }}</span><br>
                    <span class="bill-schedule">{{ firstCost }} Billed Today</span>
                </div>
            </div>

            <div class="bonus">
                <span class="includes">Includes</span><br>
                <div class="gift d-none d-md-block">
                    4 FREE<br>
                    Fun Bonus Gifts
                    <img src="/images/welcome2/Blue-Smear-Two.svg" alt="">
                </div>
                <!-- Visible Small Screen Only -->
                <div class="gift d-sm-none">
                    4 FREE Fun Bonus Gifts
                    <img src="/images/welcome2/Blue-Smear-Two.svg" alt="">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PlanDetails',
    components: {
    },
    props: [
        'plan',
        'couponCode',
        'couponValid',
        'firstCost',
        'planCost',
        'eachBilled',
        'savings'
    ],
    mounted() {
    },
    methods: {
    }
}
</script>

